import type { FlagContextType } from '@provider-directory/types/flags';

export const emptyFlags: FlagContextType = {
  featureFlags: {},
  featureFlagPayloads: {},
};
